/* Zailarah - content pages A (zp page kit, collections list, our story, journal, article).
   Plain ES2019, no dependencies. Two small custom elements:
     <zl-share>        article share links: native share sheet when available, copy-link with a "Copied" state
     <zl-pages-strip>  theme editor only: scrolls the image strip to the block selected in the editor
   Loaded with `defer` by the sections that need it. */
(function () {
  'use strict';

  var ZL = window.ZL || {};

  /* ------------------------------------------------------------ <zl-share> */
  if (!customElements.get('zl-share')) {
    customElements.define('zl-share', class ZLShare extends HTMLElement {
      constructor() {
        super();
        this._onClick = this._onClick.bind(this);
        this._timer = 0;
      }

      connectedCallback() {
        var native = this.querySelector('[data-share-native]');
        if (native && typeof navigator.share === 'function') native.hidden = false;
        this.addEventListener('click', this._onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        clearTimeout(this._timer);
      }

      get shareUrl() {
        return this.getAttribute('data-url') || window.location.href;
      }

      get shareTitle() {
        return this.getAttribute('data-title') || document.title;
      }

      _onClick(event) {
        var target = event.target && event.target.closest ? event.target.closest('button') : null;
        if (!target || !this.contains(target)) return;
        if (target.hasAttribute('data-share-native')) {
          event.preventDefault();
          this._native();
        } else if (target.hasAttribute('data-share-copy')) {
          event.preventDefault();
          this._copy(target);
        }
      }

      _native() {
        if (typeof navigator.share !== 'function') return;
        navigator.share({ title: this.shareTitle, url: this.shareUrl }).catch(function () { /* dismissed by the visitor */ });
      }

      _copy(button) {
        var self = this;
        var url = this.shareUrl;
        var done = function () { self._flash(button); };
        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
          navigator.clipboard.writeText(url).then(done, function () { if (self._legacyCopy(url)) done(); });
        } else if (this._legacyCopy(url)) {
          done();
        }
      }

      _legacyCopy(text) {
        var field = document.createElement('textarea');
        field.value = text;
        field.setAttribute('readonly', '');
        field.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
        document.body.appendChild(field);
        field.select();
        var ok = false;
        try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
        document.body.removeChild(field);
        return ok;
      }

      _flash(button) {
        var message = this.getAttribute('data-copied') || '';
        var original = this.getAttribute('data-copy-label') || button.textContent;
        var status = this.querySelector('[data-share-status]');
        clearTimeout(this._timer);
        if (message) button.textContent = message;
        if (status) status.textContent = message;
        this._timer = setTimeout(function () {
          button.textContent = original;
          if (status) status.textContent = '';
        }, 2000);
      }
    });
  }

  /* ------------------------------------------------------ <zl-pages-strip> */
  if (!customElements.get('zl-pages-strip')) {
    customElements.define('zl-pages-strip', class ZLPagesStrip extends HTMLElement {
      connectedCallback() {
        var self = this;
        if (typeof ZL.onSection !== 'function') return;
        this._off = ZL.onSection(this, {
          blockSelect: function (event) {
            var block = event.target;
            if (!block || !self.contains(block) || typeof block.scrollIntoView !== 'function') return;
            var reduce = typeof ZL.prefersReducedMotion === 'function' && ZL.prefersReducedMotion();
            block.scrollIntoView({ inline: 'center', block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
          }
        });
      }

      disconnectedCallback() {
        if (typeof this._off === 'function') this._off();
        this._off = null;
      }
    });
  }
})();
